import { Component } from '@angular/core';

@Component({
  selector: 'app-priv-0100-6-22',
  standalone: true,
  imports: [],
  templateUrl: './priv-0100-6-22.component.html',
  styleUrl: './priv-0100-6-22.component.scss'
})
export class Priv0100622Component {

}
